import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-bold text-textPrimary text-left" }, "Detalhes da avaliação", -1)
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col lg:flex-row gap-6 text-left"
}
const _hoisted_3 = { class: "flex-1 min-w-0" }
const _hoisted_4 = { class: "w-full lg:w-[380px] shrink-0 flex flex-col gap-4" }
const _hoisted_5 = { class: "flex flex-col gap-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-bold text-textPrimary" }, "Histórico", -1)
const _hoisted_7 = {
  key: 0,
  class: "flex flex-col gap-3 animate-pulse"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "w-3 h-3 rounded-full bg-slate-200 shrink-0 mt-1" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col gap-1.5 flex-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "h-3.5 w-2/3 bg-slate-200 rounded" }),
  /*#__PURE__*/_createElementVNode("div", { class: "h-3 w-1/3 bg-slate-200 rounded" })
], -1)
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = {
  key: 1,
  class: "text-sm text-negative"
}
const _hoisted_12 = {
  key: 2,
  class: "text-sm text-neutral50"
}
const _hoisted_13 = {
  key: 3,
  class: "flex flex-col"
}
const _hoisted_14 = { class: "flex flex-col items-center" }
const _hoisted_15 = {
  key: 0,
  class: "w-px flex-1 bg-[#d8d8e2] my-1"
}
const _hoisted_16 = { class: "flex flex-col gap-0.5 pb-4" }
const _hoisted_17 = { class: "text-sm text-textPrimary" }
const _hoisted_18 = { class: "font-bold" }
const _hoisted_19 = {
  key: 0,
  class: "text-neutral50"
}
const _hoisted_20 = { class: "text-xs text-neutral50" }
const _hoisted_21 = {
  key: 0,
  class: "text-sm text-textPrimary"
}
const _hoisted_22 = {
  key: 1,
  class: "text-sm text-textPrimary italic"
}
const _hoisted_23 = { class: "flex items-center justify-between w-full" }

import { computed, ref, watch } from 'vue'

import Modal from '@/components/designSystem/modals/Modal.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import {
  CheckValidationStatus,
  type CheckRejectionReason,
  type CheckValidationHistoryEvent
} from '@/Network/Types/Responses/CheckValidationResponses'
import {
  CHECK_REJECTION_REASON_LABELS,
  CHECK_VALIDATION_EVENT_TYPE_LABELS,
  CHECK_VALIDATION_STATUS_LABELS
} from '@/constants/check-validation.constants'
import { formatDateTimeBR } from '@/utils/date'
import { getFirstAndSecondName } from '@/utils/getFirstAndSecondName'

import CheckEvidencePanel from './CheckEvidencePanel.vue'
import type { CheckEvidenceContext } from './CheckEvidencePanel.vue'
import CheckSummaryCard from './CheckSummaryCard.vue'
import type { CheckValidationRow } from '../types'


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckValidationDetailsModal',
  props: {
    modelValue: { type: Boolean },
    row: {},
    history: {},
    isHistoryLoading: { type: Boolean },
    historyError: {}
  },
  emits: ["update:modelValue", "reverse"],
  setup(__props: any, { emit }) {

const props = __props;





const context = ref<CheckEvidenceContext | null>(null)

const canReverse = computed(() => props.row?.status === CheckValidationStatus.APPROVED)

const sortedEvents = computed(() =>
  [...props.history].sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  )
)

const eventLabel = (event: CheckValidationHistoryEvent): string =>
  CHECK_VALIDATION_EVENT_TYPE_LABELS[event.eventType] ?? event.eventType

const transitionLabel = (event: CheckValidationHistoryEvent): string | null => {
  if (!event.previousStatus || event.previousStatus === event.newStatus) return null
  const from = CHECK_VALIDATION_STATUS_LABELS[event.previousStatus] ?? event.previousStatus
  const to = CHECK_VALIDATION_STATUS_LABELS[event.newStatus] ?? event.newStatus
  return `${from} → ${to}`
}

const reasonLabel = (reason: CheckRejectionReason): string =>
  CHECK_REJECTION_REASON_LABELS[reason] ?? reason

function onEvidenceLoaded(loaded: CheckEvidenceContext) {
  context.value = loaded
}

watch(
  () => [props.row?.checkId, props.modelValue],
  () => {
    context.value = null
  }
)

function close() {
  emit('update:modelValue', false)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    "modal-active": _ctx.modelValue,
    "has-header-border": "",
    "has-footer-border": "",
    "max-width": "max-w-6xl",
    onClose: close
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_23, [
        _createVNode(OutlineButton, {
          text: "Fechar",
          width: "160px",
          height: "48px",
          "data-testid": "check-validation-details-close-button",
          onClick: close
        }),
        (canReverse.value)
          ? (_openBlock(), _createBlock(OutlineButton, {
              key: 0,
              text: "Reverter aprovação",
              width: "auto",
              height: "48px",
              class: "!text-negative !border-negative hover:!bg-red-50",
              "data-testid": "check-validation-details-reverse-button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('reverse', _ctx.row!)))
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    default: _withCtx(() => [
      (_ctx.row)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(CheckEvidencePanel, {
                "check-id": _ctx.row.checkId,
                "test-id-prefix": "check-validation-details",
                onLoaded: onEvidenceLoaded
              }, null, 8, ["check-id"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(CheckSummaryCard, {
                row: _ctx.row,
                "typed-hours": context.value ? { checkin: context.value.checkin, checkout: context.value.checkout } : null,
                timezone: context.value?.timezone ?? '',
                "doctor-name-override": context.value?.doctorName ?? null,
                crm: context.value?.crm ?? null
              }, null, 8, ["row", "typed-hours", "timezone", "doctor-name-override", "crm"]),
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                (_ctx.isHistoryLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (n) => {
                        return _createElementVNode("div", {
                          key: n,
                          class: "flex gap-3"
                        }, _hoisted_10)
                      }), 64))
                    ]))
                  : (_ctx.historyError)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.historyError), 1))
                    : (sortedEvents.value.length === 0)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_12, " Nenhum evento registrado. "))
                      : (_openBlock(), _createElementBlock("ol", _hoisted_13, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedEvents.value, (event, index) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: event.id,
                              class: "flex gap-3"
                            }, [
                              _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(["w-3 h-3 rounded-full shrink-0 mt-1", index === 0 ? 'bg-primary30' : 'bg-[#16161d]'])
                                }, null, 2),
                                (index < sortedEvents.value.length - 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_15))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_16, [
                                _createElementVNode("p", _hoisted_17, [
                                  _createElementVNode("span", _hoisted_18, _toDisplayString(eventLabel(event)), 1),
                                  (transitionLabel(event))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, " · " + _toDisplayString(transitionLabel(event)), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("p", _hoisted_20, _toDisplayString(_unref(formatDateTimeBR)(event.createdAt)) + ", por " + _toDisplayString(event.performedBy.name
                      ? _unref(getFirstAndSecondName)(event.performedBy.name)
                      : 'Sistema'), 1),
                                (event.rejectionReason)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_21, " Motivo: " + _toDisplayString(reasonLabel(event.rejectionReason)), 1))
                                  : _createCommentVNode("", true),
                                (event.observation)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_22, " \"" + _toDisplayString(event.observation) + "\" ", 1))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          }), 128))
                        ]))
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modal-active"]))
}
}

})